import { render, staticRenderFns } from "./SalonEnVivo.vue?vue&type=template&id=af61c608&"
import script from "./SalonEnVivo.vue?vue&type=script&lang=js&"
export * from "./SalonEnVivo.vue?vue&type=script&lang=js&"
import style0 from "./SalonEnVivo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports